import React, { useEffect } from 'react';
import { getAuth, signInWithPopup, SAMLAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import UserService from '../../utilities/services/user-service';
import OrganizationService from '../../utilities/services/organization-service';
import { UserStatus } from '../../models/enumerations/user-status';
import { useHistory } from 'react-router';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import { createLogger } from '../../utilities/logger';
import { normalizeEmail } from '../../utilities/email-util';

const log = createLogger("OktaLogin");

// const COMPONENT_CLASS = "c-okta-login";

// -----------------------------------------------------------------------------------------
// #region Intefaces
// -----------------------------------------------------------------------------------------

interface OktaLoginProps {

}

// #endregion Intefaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const OktaLogin: React.FC<OktaLoginProps> = (props: OktaLoginProps) => {
    const auth = getAuth();
    const history = useHistory();
    const { setState } = useAuthState();
    const queryParams = new URLSearchParams(window.location.search);

    const oktaAuthenticate = (() => {
        const provider = new SAMLAuthProvider("saml.okta");

        signInWithPopup(auth, provider)
            .then(async (result) => {
                // Check if user exists
                const existingUser = await UserService.getBy([{
                    field: "email",
                    operator: "==",
                    value: normalizeEmail(result.user.email ?? "")
                }])

                if (existingUser.length > 0) {
                    const oktaTile = queryParams.get("oktaTile");

                    log.info("Okta authentication succeeded", {
                        oktaTile,
                        roles: existingUser[0].roles,
                    });

                    if (oktaTile === "admin" && existingUser[0].roles && existingUser[0].roles?.length > 0) {
                        history.push("/dashboard");
                        return;
                    }

                    history.push("/wellness-assessment");
                }
                else {
                    const userDetails = getAdditionalUserInfo(result);

                    if (userDetails && userDetails.profile) {
                        const org = await OrganizationService.getBy([
                            {
                                field: "name",
                                operator: "==",
                                value: "Coral Springs", // hard-coded the organization name, because we only have Coral Springs as a client who uses OKTA
                            }
                        ])

                        if (org.length === 0) {
                            log.error("Okta authentication failed: Coral Springs organization not found", {
                                email: result.user.email as string,
                            });
                            throw new Error("Coral Springs organization not found for Okta user");
                        }

                        const user = await UserService.add({
                            email: normalizeEmail(result.user.email ?? ""),
                            groupId: null,
                            groupName: null,
                            firstName: userDetails.profile.firstName as string,
                            lastName: userDetails.profile.lastName as string,
                            organizationId: org[0].id,
                            roles: [],
                            status: UserStatus.Inactive,
                            isSuperAdmin: false,
                            tags: [],
                        });

                        log.info("Account created via Okta", {
                            userId: user.id,
                            organizationId: org[0].id,
                        });

                        setState((state) => ({
                            ...state, ...{ organization: org[0], user: user }
                        }));
                    }
                    else {
                        log.error("Okta authentication failed: user profile details missing", {
                            email: result.user.email as string,
                        });
                    }
                    history.push("/wellness-assessment");
                }
            })
            .catch((error) => {
                log.error("Okta authentication failed", {
                    exception: error,
                });
            });
    })

    useEffect(() => {
        oktaAuthenticate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
        </div>
    );
}

export { OktaLogin };
